<template>
  <div class="event">
    <p>{{ $store.getters['getClientMeta'].name }}</p>
    <h3 class="line-title">Geçmiş Bahis Hareketlerim</h3>
    
    <div class="user-content-inc table-panel">
      <Loader v-if="loading" :style="!isMobile ? 'margin-top: -35px;' : ''" />
     <slot v-if="!sportData.config.is_script">
        <slot v-if="!loading">
            <div class="panel" v-if="type == 'sportsbook'">
              <div class="title">
                <div class="col id" v-if="!isMobile">ID</div>
                <div class="col">Tür</div>
                <div class="col">Bahis</div>
                <div class="col">Kazanç</div>
                <div class="col">Durum</div>
                <div class="col">Oluşturma</div>
              </div>
              <div class="content">
                <div class="table-col">
                  <div class="item" v-for="(coupon, key) in data" :key="key">
                    <div class="col id" v-if="!isMobile">#{{ coupon.coupon_id }}</div>
                    <div class="col"><div v-if="isMobile">#{{ coupon.coupon_id }}</div> <strong>{{ coupon.coupon_type_name }}</strong></div>
                    <div class="col">{{  coupon.amount }} {{ user.currency }}</div>
                    <div class="col"><b>{{  coupon.estimated }} {{ user.currency }}</b></div>
                    <div class="col"><strong>{{  coupon.status_name }}</strong></div>
                    <div class="col">{{ coupon.created_at }}</div>
                  </div>
                  <div class="alert"  v-show="_.isEmpty(data)">
                      Sonuç bulunamadı, Lütfen tarih veya arama seçeneklerini kontrol ediniz.
                  </div>
                </div>
              </div>
            </div>
            <br>
        </slot>
        <div v-show="!loading && !_.isEmpty(data)">
          <paginate
            :page-count="filter.pageTotal"
            :page-range="6"
            :force-page="filter.page"
            :margin-pages="2"
            :click-handler="fetchData"
            :prev-text="'Geri'"
            :next-text="'İleri'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
     </slot>

			<slot v-if="sportData.config.is_script">
          <div v-if="sportData.config.is_script" v-html-js="{html: sportData.data, script:'javascript'}"></div>
          <iframe v-if="!sportData.config.is_script" :src="sportData.game_url" style="height:1000px" frameborder="0" width="100%"/>
      </slot>
    </div>
  </div>
</template>
<script>
  import DatePicker from 'vuejs-datepicker';
  import {tr, en} from 'vuejs-datepicker/dist/locale'

  import Header from '../../components/Common/User/Header'
  import FilterPanel from '../../components/Common/User/FilterPanel'

  export default{
    data(){
      return{
        type:'sportsbook',
        tr: tr,
        en: en,
        sportData:{
          config:{
            is_script:false
          }
        },
        mobileFilter: false,
        loading: false,
        btnLoading:false,
        data: [],
        filter:{
          pageTotal: 0,
          size: 10,
          page: 1,
          isLoading: false,
          start_date: this.$moment().format('YYYY-MM-DD'),
          end_date: this.$moment().format('YYYY-MM-DD'),
          type: 'sportsbook'
        },
      }
    },
    components:{
      Header,
      FilterPanel,
      DatePicker
    },
    watch:{
      mobileFilter(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      }
    },
    created(){
      this.fetchData()
      if(this.isMobile){
          document.querySelector("body").style.setProperty('--mobileHeight', window.innerHeight - 210 + 'px');
      }
    },
    computed:{
        user(){
          return this.$user();
        },
    },
    methods:{
        fetchData(page = 1, size = null, silent = false)
        {
          this.filter.page = page;

          if (!_.isNull(size)) 
          {
              this.filter.size = size;
          }
          
          if(silent == false){
            this.loading = true;
          } 
          this.sportData.config.is_script = false;
          axios.get('/user/history', {params: this.filter }).then((response) => {
              if(this.filter.type == 'sportsbook' && !_.isUndefined(response.data.config)){
                this.sportData = response.data
              }
              this.data       					  = response.data.data.data;
              this.filter.pageTotal  = response.data.data.last_page;
              this.type = this.filter.type;

              
          }).catch(() => {}).finally(() => {
              this.loading = false;
              this.btnLoading = false;
          });
          this.mobileFilter = false;
        },
        filter_open(){
          this.mobileFilter = true;
        },
        filterBtn(){
          this.btnLoading = true;
          this.fetchData();
        },
    }
  }
 </script>